import React, { FC } from 'react';
import { SearchFiltersBarDecision } from './SearchFiltersBarDecision';
import { SearchFiltersBarLegislation } from './SearchFiltersBarLegislation';
import { Connect, PropsFromRedux } from './SearchFiltersBarContainer';
import { SearchFiltersBarCommentary } from './SearchFiltersBarCommentary';
import { SearchTypeSelector } from './type-selector/SearchTypeSelector';
import styles from './search_filters_bar.module.scss';

type Props = PropsFromRedux;

const RawSearchFiltersBar: FC<Props> = ({ enableTypeSelector, type }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.subHeader}>
          {enableTypeSelector && <SearchTypeSelector />}
          {type === 'arret' && <SearchFiltersBarDecision />}
          {type === 'commentary' && <SearchFiltersBarCommentary />}
          {type === 'law' && <SearchFiltersBarLegislation />}
        </div>
      </div>
    </div>
  );
};

export const SearchFiltersBar = Connect(RawSearchFiltersBar);
